import { Suspense, useContext, useEffect } from "react";

import { ComponentSpinner } from "@components/spinner";
import Layout from "./layout";
import { Outlet } from "react-router-dom";
import { UserContext } from "@context/user";
import { checkForAdBlocker } from "@helpers/utils";
import { ProductProvider } from "@src/utility/context/product";

// ** Custom Component
const VerticalLayout = (props) => {
    const { loading } = useContext(UserContext);
    useEffect(() => {
        checkForAdBlocker();
    }, []);
    return (
        <Suspense fallback={<ComponentSpinner />}>
            <ProductProvider>
                <Layout {...props}>
                    {loading ? <ComponentSpinner /> : <Outlet />}
                </Layout>
            </ProductProvider>
        </Suspense>
    );
    
};

export default VerticalLayout;
